<template>
  <svg
    width="240"
    height="240"
    viewBox="0 0 240 240"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="240" height="240" fill="white" />
    <rect x="64" y="64" width="112" height="112" rx="56" fill="#A0CDFC" />
    <rect
      x="58"
      y="58"
      width="124"
      height="124"
      rx="62"
      stroke="#20518C"
      stroke-width="4"
    />
    <rect x="80" y="80" width="80" height="80" rx="40" fill="white" />
    <rect
      width="16"
      height="90"
      transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 157.477 93.8379)"
      fill="#A0CDFC"
    />
  </svg>
</template>
